import { render, staticRenderFns } from "./EditQuestionarioCompilato.vue?vue&type=template&id=56895ede&scoped=true&"
import script from "./EditQuestionarioCompilato.vue?vue&type=script&lang=js&"
export * from "./EditQuestionarioCompilato.vue?vue&type=script&lang=js&"
import style0 from "./EditQuestionarioCompilato.vue?vue&type=style&index=0&id=56895ede&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56895ede",
  null
  
)

export default component.exports